import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "assignPersonCheckBox", "createPersonCheckBox",
    "assignForm", "newForm",
    "personSelection",
    "requiresUserAccountSelect",
    "userAccountFields",
  ]

  connect() {
    this.toggleSelect()
    this.initUserAccountFields()
  }

  toggleSelect() {
    const value = this.personSelectionTarget.value

    if (value === "assign_authorized_people") {
      this.assignPersonCheckBoxTarget.checked = true
      this.createPersonCheckBoxTarget.checked = false
      this.assignFormTarget.classList.remove("hidden")
      this.newFormTarget.classList.add("hidden")
    } else if (value === "create_new_authorized_person") {
      this.createPersonCheckBoxTarget.checked = true
      this.assignPersonCheckBoxTarget.checked = false
      this.assignFormTarget.classList.add("hidden")
      this.newFormTarget.classList.remove("hidden")
    } else {
      this.assignPersonCheckBoxTarget.checked = false
      this.createPersonCheckBoxTarget.checked = false
      this.assignFormTarget.classList.add("hidden")
      this.newFormTarget.classList.add("hidden")
    }
  }

  initUserAccountFields() {
    if (!this.hasRequiresUserAccountSelectTarget) return
    const value = this.requiresUserAccountSelectTarget.value
    if (value === "1") {
      this.userAccountFieldsTarget.classList.remove("hidden")
    } else {
      this.userAccountFieldsTarget.classList.add("hidden")
    }
  }

  toggleUserAccount(event) {
    if (event.target.value === "1") {
      this.userAccountFieldsTarget.classList.remove("hidden")
    } else {
      this.userAccountFieldsTarget.classList.add("hidden")
    }
  }
}
